import { PageViewEventLogger } from '@repo/tracking-service';
import { GetServerSideProps } from 'next';

import { SurveyLayout } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { UserInputEmployeeFormContainer } from '@/components/survey/employment/special-relationships/UserInputEmployeeFormContainer';

interface AdditionalSpecialRelationshipsEmployeeFormPageProps {
  id: string;
}

function AdditionalSpecialRelationshipsEmployeeFormPage({ id }: AdditionalSpecialRelationshipsEmployeeFormPageProps) {
  const eventAttributes = useSurveyUserEventAttributes();

  return (
    <PageViewEventLogger pageName={'survey_special-relationships-info'} eventProperty={eventAttributes}>
      <UserInputEmployeeFormContainer id={id} />
    </PageViewEventLogger>
  );
}

export const getServerSideProps: GetServerSideProps<AdditionalSpecialRelationshipsEmployeeFormPageProps> = async (context) => {
  const { id } = context.query;

  const idString = Array.isArray(id) ? id[0] : id || '';

  return {
    props: {
      id: idString || ''
    }
  };
};

AdditionalSpecialRelationshipsEmployeeFormPage.getLayout = SurveyLayout;

export default AdditionalSpecialRelationshipsEmployeeFormPage;
